import { render, staticRenderFns } from "./DetailedSlotGeneric.vue?vue&type=template&id=e9e512bc&"
import script from "./DetailedSlotGeneric.vue?vue&type=script&lang=ts&"
export * from "./DetailedSlotGeneric.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedSlotGeneric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports